import type { ReactNode } from "react";
import Eyebrow from "@/components/base/Eyebrow";

interface PageHeroProps {
  eyebrow: string;
  title: string;
  description: string;
  children?: ReactNode;
}

export default function PageHero({ eyebrow, title, description, children }: PageHeroProps) {
  return (
    <section className="relative overflow-hidden bg-background-50 border-b-2 border-foreground-950 pt-28 md:pt-32 pb-12 md:pb-16">
      <div className="absolute inset-0 grid-pattern opacity-70 pointer-events-none" aria-hidden="true"></div>
      <div className="absolute right-0 top-0 h-full w-1.5 bg-primary-500 hidden md:block"></div>

      <div className="relative px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <Eyebrow>{eyebrow}</Eyebrow>
          <h1 className="mt-6 font-heading font-black uppercase leading-[0.9] tracking-tight text-foreground-950 text-4xl md:text-6xl lg:text-7xl max-w-4xl">
            {title}
          </h1>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-foreground-600 max-w-2xl">
            {description}
          </p>
          {children}
        </div>
      </div>
    </section>
  );
}